import React, { useState, useContext } from 'react';
import { Pane, Tablist, Tab, Card, LockIcon } from 'evergreen-ui';

import VendasContext from '../../../../context/VendasContext';

import TabVenda from './Tabs/Rascunho/Venda';
import TabVendedores from './Tabs/Rascunho/Vendedores';
import TabCompradores from './Tabs/Rascunho/Compradores';

export default function Rascunho() {
    const {
        //sideId, sideProcesso,
        //selectedIndexEnviados, setSelectedIndexEnviados,
        dadosReciboEnviado,
        selectedIndexRascunho, setSelectedIndexRascunho,
        showTabsRascunho
    } = useContext(VendasContext);


    const [tabsRascunho] = useState(['Venda', 'Vendedor', 'Comprador']);

    const verificarTabs = async () => {
        if(dadosReciboEnviado.status_processo >= 1 && dadosReciboEnviado.status_processo <= 8){
            showTabsRascunho[1] = true;
            showTabsRascunho[2] = true;
        }
        else{
            if(dadosReciboEnviado.status_processo >= 10){
                showTabsRascunho[1] = true;
            }
            //if(dadosReciboEnviado.status_processo >= 11){
            if(dadosReciboEnviado.status_processo === 11 && dadosReciboEnviado.status_processo !== 24
                || (dadosReciboEnviado.status_processo >= 15 && dadosReciboEnviado.status_processo !== 24)
                || (dadosReciboEnviado.status_processo === 11 && dadosReciboEnviado.status_anterior_processo_id === 15)
                || (dadosReciboEnviado.status_processo === 15 && dadosReciboEnviado.status_anterior_processo_id === 11)
                //|| (dadosReciboEnviado.status_processo === 11 && dadosReciboEnviado.status_anterior_processo_id === 23)
                //|| (dadosReciboEnviado.status_processo >= 15 && dadosReciboEnviado.status_anterior_processo_id === 23)
            ){
                showTabsRascunho[2] = true;
            }
            else{
                showTabsRascunho[2] = false;
            }
        }
    }
    verificarTabs();

    return (
        <Pane>
            <Pane zIndex={1} flexShrink={0} elevation={0} backgroundColor="white">
                <Pane display="flex" padding={8}>
                    <Tablist>
                        {tabsRascunho.map((tabRascunho, index) => (
                            <Tab
                                key={tabRascunho}
                                isSelected={selectedIndexRascunho === index}
                                onSelect={() => setSelectedIndexRascunho(index)}
                                aria-controls={`panel-${index}`}
                                aria-selected={selectedIndexRascunho === index ? true : false}
                                //className='tab-enable'
                                className={
                                    showTabsRascunho[index] === true ? 'tab-enable' : 'tab-disable'
                                }
                                style={selectedIndexRascunho === index ? { boxShadow: '0 0 0 2px #d6e0ff' } : { boxShadow: 'none' }}
                            >
                                {tabRascunho} {showTabsRascunho[index] === true ? '' : <LockIcon size={12} marginLeft={10}/>}
                            </Tab>
                        ))}
                    </Tablist>
                </Pane>
            </Pane>
            <Pane flex="1" overflowY="scroll" background="tint1" padding={16}>
                {tabsRascunho.map((tabRascunho, index) => (
                    <Card
                        key={tabRascunho}
                        id={`panel-${tabRascunho}`}
                        role="tabpanel"
                        aria-labelledby={tabRascunho}
                        aria-hidden={index !== selectedIndexRascunho}
                        display={index === selectedIndexRascunho ? 'block' : 'none'}
                    >
                        {/*Id do processo - sideId*/}
                        {tabRascunho === 'Venda' && <TabVenda />}
                        {tabRascunho === 'Vendedor' && <TabVendedores />}
                        {tabRascunho === 'Comprador' && <TabCompradores />}
                    </Card>
                ))}
            </Pane>
        </Pane>
    )
}